import type { Currency } from '@mfw/common';

import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchPremiumReportSubscription,
  fetchPremiumSubscription,
  fetchPremiumPlans,
} from '../api/premium.api';

export const premiumQueryKeys = createQueryKeys('premium', {
  fetchPlans: (currency?: Currency) => ({
    queryFn: () => fetchPremiumPlans(currency),
    queryKey: [currency ?? 'all'],
  }),
  // Task 7.1 — per ORGANIZATION (the organization pays)
  fetchReportSubscription: (organizationId: string) => ({
    queryFn: () => fetchPremiumReportSubscription(organizationId),
    queryKey: [organizationId],
  }),
  fetchSubscription: {
    queryFn: () => fetchPremiumSubscription(),
    queryKey: null,
  },
});
